import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import InputField from "../framework/InputField/InputField";
import Dropzone from "react-dropzone";
import CustomSelect from "../framework/CustomSelect/CustomSelect";
import MaskedInput from "react-text-mask";
import groupBy from "lodash/groupBy";
import Dialog from "material-ui/Dialog";
import Checkbox from "material-ui/Checkbox";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
// button color
import { buttonBlueColor } from "../../utils/utility";
import Error from "material-ui/svg-icons/alert/error";
// import web workers;
import profileWorker from "./worker";
import Select from "react-select";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { omit, isEmpty, isArray } from "lodash";
// css
import "./client-profile.css";
var validator = require("email-validator");

const styles = {
  iconStyle: {
    fill: "#000000",
    transform: "scale(0.9)",
    WebkitTransform: "scale(0.9)",
    MsTransform: "scale(0.9)",
    MozTransform: "scale(0.9)",
    marginRight: "13px",
    marginLeft: "-1px",
  },
  labelStyle: {
    lineHeight: "15px",
    marginBottom: 0,
    paddingTop: "3px",
    fontWeight: "normal",
  },
};

class Profile extends Component {
  constructor(props) {
    super(props);
    this.flag = true;
    this.flagBase = true;
    this.flagPhoto = true;
    this.myProfile_worker = new Worker(profileWorker);
    const months = [
      { value: "01", label: "Jan" },
      { value: "02", label: "Feb" },
      { value: "03", label: "Mar" },
      { value: "04", label: "Apr" },
      { value: "05", label: "May" },
      { value: "06", label: "Jun" },
      { value: "07", label: "Jul" },
      { value: "08", label: "Aug" },
      { value: "09", label: "Sep" },
      { value: "10", label: "Oct" },
      { value: "11", label: "Nov" },
      { value: "12", label: "Dec" },
    ];
    const years = [];
    for (var i = 0; i < 10; i++) {
      years.push({
        value: moment().add(i, "years").format("YYYY"),
        label: moment().add(i, "years").format("YYYY"),
      });
    }

    this.state = {
      expMonth: null,
      expYear: null,
      years: years,
      months: months,
      disableCloseBtn: true,
      consumerDataSource:
        window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
      businessDataSource: "InfoGroup",
      requiredNameText: "", // requied field firset name tip text
      requiredEmailText: "",
      requiredTimezoneText: "", // required field last name tip text
      requiredTierText: "", // required field email tip text
      requiredIndustryIdText: "", // requierd industry text
      requiredAssignClientText: "", // assign client text
      ifLogoUploadButtonEnable: false, // if upload button enable for logo
      ifPhotoUploadButtonEnable: false, // if uploda button enable for photo
      ifLogoSaveBtnEnable: false, // if logo save button can be request api
      ifPhotoSaveBtnEnable: false, // if photo save button can be request api
      logoFileName: "No file chosen",
      logoUploadSuccess: false,
      photoUploadSucess: false,
      campaignReportPreference: "Aggregated",
      consumerRecords: 500, // consumer default value
      businessRecords: 200, // business default value
      roleValue: "",
      stateValue: "",
      timezoneValue: "",
      industryValue: "",
      subscriptionTierValue: /^\/clients$/g.test(this.props.path)
        ? /^(administrator|team member)/gi.test(this.props.roleName)
          ? 2
          : 2
        : 2,
      assignClientValue: [""],
      clientId: "", // client id for upload
      companyLogoErrorText: "",
      profilePhotoErrorText: "",
      userAvatarUuid: "",
      roleInfo: "", // store role object information,
      industryGroupObj: [], // for the new industry group obj
      requestParams: {
        name: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        phone: "",
        timezone: "",
        industryId: "",
        accountNumber: "",
        subscriptionTierId: /^\/clients$/g.test(this.props.path)
          ? /^(administrator|team member)/gi.test(this.props.roleName)
            ? 2
            : 2
          : 2,
        logoUuid: "",
        accountManagerUserIds: [""],
        campaignReportPreference: "Aggregated",
      },
      // password_error_tip_show: false,
      newLogoBase64: "",
      showNewPwError: false,
      showConfirmPwError: false,
      segmentationSystem: "prizm_premier",
      appendSegmentation: false,
      audienceResolutionGranularity: "Scale",
      // showBaseInfoError: false
    };
  }
  componentDidMount() {
    // this.props.getRoles();
    this.props.getStates();
    this.props.getTimezone();
    localStorage.setItem("newLogoBase64", "");
    localStorage.setItem("newPhotoBase64", "");
    // init value when subscription tier value is 1
    if (
      this.state.requestParams.subscriptionTierId === 1 &&
      this.refs.consumer &&
      this.refs.business
    ) {
      this.refs.consumer.value = this.state.consumerRecords;
      this.refs.business.value = this.state.businessRecords;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      /^Please add a contract number/g.test(
        nextProps.createClientProfileMessage,
      )
    ) {
      this.setState({
        ifShowContractNumber: true,
        contractNumberText: "Please add a contract number",
      });
    }
    // change blob to base64 for photo
    if (typeof nextProps.avatar !== "undefined") {
      if (this.flagPhoto) {
        let reader = new FileReader();
        reader.readAsDataURL(nextProps.avatar);
        reader.onload = () => {
          this.setState({
            imgPhotoDataBase64: reader.result,
          });
        };
      }
    }
    if (nextProps.loginUserDetail) {
      const { role, id } = nextProps.loginUserDetail;
      this.setState(
        {
          clientId: id,
        },
        () => {
          // account manager get config insights standard datas
          // if (/^account manager/gi.test(nextProps.roleInfo)) {
          //   nextProps.getConfigInsightsStandard(this.state.clientId)
          // }
        },
      );

      this.setState({
        roleInfo: role,
      });
    }

    if (nextProps.industryOptions.length > 0) {
      this.setState({
        industryValue: "",
      });

      let industryGroup = groupBy(nextProps.industryOptions, "group");
      let obj = [];
      // obj.push({label: 'All Industries', options: [
      //   {
      //     label: 'All Industries',
      //     value: ''
      //   }
      // ]})
      for (let x in industryGroup) {
        obj.push({
          label: x,
          options: industryGroup[x],
        });
      }
      this.setState({
        industryGroupObj: obj,
      });
    }
    /*
    if (nextProps.clientId !== '') {
      if (this.state.requestParams.subscriptionTierId >= 3 || this.state.requestParams.subscriptionTierId === 1) {
        nextProps.configInsightsStandard(nextProps.clientId, {
          // id: this.props.match.params.businessUnitId,
          maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
          maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
          consumerDataSource: this.state.consumerDataSource,
          businessDataSource: 'InfoGroup'
        })
      }
    }*/
  }
  handleItemsChange(e, index, value) {
    this.setState({
      roleValue: value,
    });
  }
  handleStateChange(value) {
    this.setState({
      stateValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        state: value.value,
      },
    });
  }
  handleExpMonthChange(value) {
    this.setState({
      expMonth: value.value,
    });
  }
  handleExpYearChange(value) {
    this.setState({
      expYear: value.value,
    });
  }
  handleTimeZoneChange(value) {
    this.setState({
      timezoneValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        timezone: value.value,
      },
    });
  }

  handleClientName(e, value) {
    const notAllowedRegex =  /[\"*\/:<>?\\|\+,.;=\[\]\']/;
    if (notAllowedRegex.test(value)) {
        this.setState({
          requiredNameText: 'Client Name cannot contain any of the following special characters: \" / * : < > ? \ | + \' , . ; = [ ] .',
          requestParams: {
            ...this.state.requestParams,
            name: value,
          },
        })
        return ;
    } else {
     this.setState({
        requiredNameText: '',
        requestParams: {
          ...this.state.requestParams,
          name: value,
        },
    });
    }
  }
  handleLicenseNumber(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
      },
      licenseNum: value,
    });
  }
  handleClientAddress1(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address1: value,
      },
    });
  }
  handleClientAddress2(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address2: value,
      },
    });
  }
  handleIndustryChange(value) {
    this.setState({
      industryValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        industryId: value.value,
      },
    });
  }
  handleCity(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        city: value,
      },
    });
  }
  handleZipCode(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        zipCode: value,
      },
    });
  }
  handleOfficePhoneNumber(e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        phone: e.target.value,
      },
    });
  }
  handleSubscriptionTierChange(value) {
    this.setState(
      {
        consumerDataSource:
          window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
        subscriptionTierValue: value,
        requestParams: {
          ...this.state.requestParams,
          subscriptionTierId: value,
        },
      },
      () => {
        if (
          ((value >= 3 && value !== 5) || value === 1) &&
          this.refs.consumer &&
          this.refs.business
        ) {
          this.refs.consumer.value = this.state.consumerRecords;
          this.refs.business.value = this.state.businessRecords;
        }
      },
    );
  }
  handleAssignClientChange(value) {
    this.setState({
      assignClientValue: value,
      requestParams: {
        ...this.state.requestParams,
        accountManagerUserIds: value,
      },
    });
  }
  handleAccountNumber(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        accountNumber: value,
      },
    });
  }
  handleDrop(files, accept, reject) {
    this.setState({
      logoFileName: files[0],
      ifLogoUploadButtonEnable: true,
      companyLogoErrorText: "",
    });
  }
  handleCampaignReportChanged(value) {
    if (value === "Detailed") {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          campaignReportPreference: value,
          clientReportDetailSetting: {
            topLocationChannelReport: 0,
          },
        },
      });
    } else {
      const {
        /*clientReportDetailSetting, */ ...others
      } = this.state.requestParams;
      this.setState({
        requestParams: {
          ...others,
          campaignReportPreference: value,
        },
      });
    }
  }
  handleTopLocationReportCheck(e, isChecked) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        clientReportDetailSetting: {
          topLocationChannelReport: isChecked ? 1 : 0,
        },
      },
    });
  }
  onDropRejected() {
    this.setState({
      companyLogoErrorText:
        "Only jpg, png, and gif file with maximum size of 1MB is allowed",
    });
  }
  handleUpdateProfile() {
    if (
      /^account manager/gi.test(this.props.roleName) &&
      typeof this.state.requestParams.contractNumber === "undefined"
    ) {
      this.setState({
        ifShowContractNumber: true,
        contractNumberText: "Please add a contract number",
      });
    }
    const notAllowedRegex =  /[\"*\/:<>?\\|\+,.;=\[\]\']/;
    if (notAllowedRegex.test(this.state.requestParams.name)) {
      this.setState({
        requiredNameText: 'Client Name cannot contain any of the following special characters: \" / * : < > ? \ | + \' , . ; = [ ] .'
      })
      return ;
    }
    if (this.state.requestParams.name.trim().length === 0) {
      /^(administrator|team member)/gi.test(this.props.roleName)
        ? this.setState({
            requiredNameText: "Please enter your business unit name",
          })
        : this.setState({
            requiredNameText: "Please enter your client name",
          });
    } else {
      this.setState({
        requiredNameText: "",
      });
    }
    if (this.state.requestParams.subscriptionTierId === 5) {
      this.setState({
        requiredEmailText: "",
      });
      if (this.state.requestParams.email.trim().length === 0) {
        this.setState({
          requiredEmailText: "Please enter email address",
        });
      } else {
        if (!validator.validate(this.state.requestParams.email.trim())) {
          this.setState({
            requiredEmailText: "Invalid email address",
          });
        }
      }
    }
    if (this.state.requestParams.timezone.trim().length === 0) {
      this.setState({
        requiredTimezoneText: "Please select your time zone",
      });
    } else {
      this.setState({
        requiredTimezoneText: "",
      });
    }
    if (
      typeof this.state.requestParams.subscriptionTierId === "string" &&
      /^(system administrator|account manager|operations manager)/gi.test(
        this.props.roleName,
      )
    ) {
      this.setState({
        requiredTierText: "Please select your subscription tier",
      });
    } else {
      this.setState({
        requiredTierText: "",
      });
    }
    if (typeof this.state.requestParams.industryId === "string") {
      this.setState({
        requiredIndustryIdText: "Please select your industry type",
      });
    } else {
      this.setState({
        requiredIndustryIdText: "",
      });
    }
    if (this.state.requestParams.subscriptionTierId == 4) {
      if (this.state.appendSegmentation === true) {
        if (
          !this.state.licenseNum ||
          !this.state.expMonth ||
          !this.state.expYear
        ) {
          this.setState({
            licenseErrorText:
              "Please input license number and select expiration time",
          });
        } else {
          this.setState({
            licenseErrorText: null,
          });
        }
      } else {
        this.setState({
          licenseErrorText: null,
        });
      }
    } else {
      this.setState({
        licenseErrorText: null,
      });
    }
    if (
      Array.isArray(this.state.requestParams.accountManagerUserIds) &&
      isEmpty(this.state.requestParams.accountManagerUserIds[0]) &&
      !/^(team member|account manager)/gi.test(this.props.roleName) &&
      !/^(administrator|team member)/gi.test(this.props.roleName)
    ) {
      this.setState({
        requiredAssignClientText: "Please select assignee",
      });
      // for system administrator create client profile
      if (/^(system administrator)/gi.test(this.props.roleName)) {
        return;
      }
    } else {
      this.setState({
        requiredAssignClientText: "",
      });
    }
    const { requestParams } = this.state;

    if (
      requestParams.accountManagerUserIds &&
      (requestParams.accountManagerUserIds[0] === "" ||
        requestParams.accountManagerUserIds === "")
    ) {
      requestParams.accountManagerUserIds = undefined;
    } else {
      requestParams.accountManagerUserIds =
        typeof requestParams.accountManagerUserIds === "number"
          ? [requestParams.accountManagerUserIds]
          : requestParams.accountManagerUserIds
          ? isArray(requestParams.accountManagerUserIds)
            ? requestParams.accountManagerUserIds
            : requestParams.accountManagerUserIds.split(",")
          : undefined;
    }
    // if (/^(\/clients\/edit\/Business-Units\/:id)/g.test(this.props.path)) {
    //   if (this.state.requestParams.name.trim().length > 0 &&
    //     this.state.requestParams.timezone.trim().length > 0 &&)
    //
    //   return;
    // }
    // for internal account
    if (
      /^(system administrator)/gi.test(this.props.roleName) &&
      this.state.requestParams.name.trim().length > 0 &&
      this.state.requestParams.timezone.trim().length > 0 &&
      typeof this.state.requestParams.industryId === "number" &&
      typeof this.state.requestParams.subscriptionTierId === "number"
    ) {
      // for create client profile (system admini)
      if (
        this.state.requestParams.subscriptionTierId >= 3 &&
        this.state.requestParams.subscriptionTierId != 5
      ) {
        const requestData = {
          ...requestParams,
          insightsStandardConfig: {
            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
            consumerDataSource: this.state.consumerDataSource,
            businessDataSource: this.state.businessDataSource,
          },
          audienceResolutionGranularity: this.state
            .audienceResolutionGranularity,
        };
        if (this.state.requestParams.subscriptionTierId === 4) {
          requestData.insightsStandardConfig["segmentationSystem"] = this.state
            .segmentationSystem
            ? this.state.segmentationSystem
            : "prizm_premier";
          requestData.insightsStandardConfig["appendSegmentation"] = this.state
            .appendSegmentation
            ? this.state.appendSegmentation
            : false;
          if (this.state.appendSegmentation === true) {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = this.state.licenseNum;
            requestData.insightsStandardConfig["licenseExpirationDate"] =
              this.state.expYear + "-" + this.state.expMonth + "-01";
          } else {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = null;
            requestData.insightsStandardConfig["licenseExpirationDate"] = null;
          }
        }
        this.props.createClientProfile(requestData, this.props.paramId);
      } else {
        this.props.createClientProfile(
          this.state.requestParams,
          this.props.paramId,
        );
      }
      // if (this.state.requestParams.subscriptionTierId === 3 || this.state.requestParams.subscriptionTierId === 1) {
      //   setTimeout(() => {
      //     this.props.configInsightsStandard(localStorage.getItem('createClientProfileId'), {
      //       // id: this.props.match.params.businessUnitId,
      //       maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords),
      //       maxMonthlyBusinessRecords: parseInt(this.state.businessRecords),
      //       consumerDataSource: this.state.consumerDataSource,
      //       businessDataSource: 'InfoGroup'
      //     })
      //     this.setState({
      //       disableCloseBtn: false
      //     })
      //   }, 3000)
      // }
    } else if (
      this.state.requestParams.name.trim().length > 0 &&
      this.state.requestParams.timezone.trim().length > 0 &&
      typeof this.state.requestParams.industryId === "number" &&
      typeof this.state.requestParams.subscriptionTierId === "number"
    ) {
      // for create client profile and create business unit profile (account manager)
      if (
        this.state.requestParams.subscriptionTierId >= 3 &&
        this.state.requestParams.subscriptionTierId != 5
      ) {
        const { requestParams } = this.state;
        const requestData = {
          ...requestParams,
          insightsStandardConfig: {
            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
            consumerDataSource: this.state.consumerDataSource,
            businessDataSource: "InfoGroup",
          },
          audienceResolutionGranularity: this.state
            .audienceResolutionGranularity,
        };
        if (this.state.requestParams.subscriptionTierId === 4) {
          requestData.insightsStandardConfig["segmentationSystem"] = this.state
            .segmentationSystem
            ? this.state.segmentationSystem
            : "prizm_premier";
          requestData.insightsStandardConfig["appendSegmentation"] = this.state
            .appendSegmentation
            ? this.state.appendSegmentation
            : false;
          if (this.state.appendSegmentation === true) {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = this.state.licenseNum;
            requestData.insightsStandardConfig["licenseExpirationDate"] =
              this.state.expYear + "-" + this.state.expMonth + "-1";
          } else {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = null;
            requestData.insightsStandardConfig["licenseExpirationDate"] = null;
          }
        }
        this.props.createClientProfile(requestData, this.props.paramId);
      } else {
        this.props.createClientProfile(
          this.state.requestParams,
          this.props.paramId,
        );
      }
      // if (this.state.requestParams.subscriptionTierId === 3 || this.state.requestParams.subscriptionTierId === 1) {
      //   setTimeout(() => {
      //     this.props.configInsightsStandard(localStorage.getItem('createClientProfileId'), {
      //       // id: this.props.match.params.businessUnitId,
      //       maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords),
      //       maxMonthlyBusinessRecords: parseInt(this.state.businessRecords),
      //       consumerDataSource: this.state.consumerDataSource,
      //       businessDataSource: 'InfoGroup'
      //     })
      //     this.setState({
      //       disableCloseBtn: false
      //     })
      //   }, 3000)
      // }
    } else if (
      // for business unit
      this.state.requestParams.name.trim().length > 0 &&
      this.state.requestParams.timezone.trim().length > 0 &&
      typeof this.state.requestParams.industryId === "number"
    ) {
      if (/^administrator/gi.test(this.props.roleName)) {
        if (isEmpty(this.state.requestParams.accountManagerUserId)) {
          this.props.createClientProfile(
            omit(this.state.requestParams, "accountManagerUserIds"),
            this.props.paramId,
          );
        } else {
          this.props.createClientProfile(
            this.state.requestParams,
            this.props.paramId,
          );
        }
      } else {
        this.props.createClientProfile(this.state.requestParams);
      }
    } else if (
      // create business unit profile(system|account manager)
      this.state.requestParams.name.trim().length > 0 &&
      this.state.requestParams.timezone.trim().length > 0 &&
      typeof this.state.requestParams.industryId === "number"
    ) {
      if (/^(administrator|team member)/gi.test(this.props.roleInfo)) {
        this.setState({
          disableCloseBtn: false,
        });
      }
      if (
        this.state.requestParams.subscriptionTierId >= 3 &&
        this.state.requestParams.subscriptionTierId != 5
      ) {
        const { requestParams } = this.state;
        const requestData = {
          ...requestParams,
          insightsStandardConfig: {
            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
            consumerDataSource: this.state.consumerDataSource,
            businessDataSource: this.state.businessDataSource,
          },
          audienceResolutionGranularity: this.state
            .audienceResolutionGranularity,
        };
        if (this.state.requestParams.subscriptionTierId === 4) {
          requestData.insightsStandardConfig["segmentationSystem"] = this.state
            .segmentationSystem
            ? this.state.segmentationSystem
            : "prizm_premier";
          requestData.insightsStandardConfig["appendSegmentation"] = this.state
            .appendSegmentation
            ? this.state.appendSegmentation
            : false;
          if (this.state.appendSegmentation === true) {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = this.state.licenseNum;
            requestData.insightsStandardConfig["licenseExpirationDate"] =
              this.state.expYear + "-" + this.state.expMonth + "-1";
          } else {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = null;
            requestData.insightsStandardConfig["licenseExpirationDate"] = null;
          }
        }
        this.props.createClientProfile(requestData, this.props.paramId);
      } else {
        this.props.createClientProfile(
          this.state.requestParams,
          this.props.paramId,
        );
      }
    }
  }
  handleUploadLogo() {
    if (this.state.ifLogoUploadButtonEnable) {
      let formData = new FormData();
      formData.append("logo", this.state.logoFileName);
      // call api
      let url = /^(system administrator|account manager|team member|administrator)/gi.test(
        this.props.roleName,
      )
        ? `/api/clients/logo/upload`
        : `/api/clients/${this.state.roleInfo.id}/logo/upload`;
      fetch(url, {
        method: "POST",
        body: formData,
        headers: new Headers({
          Authorization: this.props.token,
        }),
      })
        .then(
          (res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              res.json().then((json) => {
                this.setState({
                  companyLogoErrorText: json.message,
                });
              });
            }
          },
          () => {},
        )
        .then((json) => {
          if (typeof json !== "undefined") {
            localStorage.setItem(
              "newLogoBase64",
              this.state.logoFileName.preview,
            );
            this.setState({
              companyLogoErrorText: "",
              newLogoBase64: this.state.logoFileName.preview,
              requestParams: {
                ...this.state.requestParams,
                logoUuid: json.uuid,
              },
            });
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }

  handleClientProfileCancel() {
    this.props.clientProfileCancel();
    this.props.rollbackProfileStatus();
  }
  handleCloseCreateClientProfile() {
    this.props.rollbackProfileStatus(false);
    this.setState(
      {
        logoUploadSuccess: false,
        photoUploadSucess: false,
        requiredNameText: "",
        requiredTimezoneText: "",
        requiredTierText: "",
        requiredIndustryIdText: "",
        ifLogoUploadButtonEnable: false,
        ifPhotoUploadButtonEnable: false,
        logoFileName: "No file chosen",
        roleValue: "",
        stateValue: "",
        timezoneValue: "",
        industryValue: "",
        subscriptionTierValue: "",
        assignClientValue: "",
        clientId: "", // client id for upload
        companyLogoErrorText: "",
        profilePhotoErrorText: "",
        companyLogoUuid: "", // logo uuid
        userAvatarUuid: "", // avatar uuid
        requestParams: {
          name: "",
          address1: "",
          address2: "",
          city: "",
          state: "",
          zipCode: "",
          phone: "",
          timezone: "",
          industryId: "",
          subscriptionTierId: "",
          accountManagerUserIds: [""],
          logoUuid: "",
        },
        ifShowContractNumber: false,
        passwordRequestParams: {
          password: Math.random().toString(36).substr(2),
          confirmPassword: "",
        },
        newLogoBase64: "",
        // showBaseInfoError: false
      },
      () => {
        this.props.clientProfileCancel();
      },
    );
  }
  handleConsumerRecords(e) {
    if (e.target.value > 1000000) {
      this.refs.consumer.value = 1000000;
    } else if (!/^[0-9]*$/g.test(e.target.value)) {
      this.refs.consumer.value = 0;
    } else {
      this.setState({
        consumerRecords: e.target.value,
      });
    }
  }
  handleBusinessRecords(e) {
    if (e.target.value > 1000000) {
      this.refs.business.value = 1000000;
    } else if (!/^[0-9]*$/g.test(e.target.value)) {
      this.refs.business.value = 0;
    } else {
      this.setState({
        businessRecords: e.target.value,
      });
    }
  }
  handleAccoundDownloadOptions(e, value) {
    this.setState({
      audienceResolutionGranularity: value,
    });
  }
  handle3rdPartyData(e, value) {
    this.setState({
      consumerDataSource: value,
    });
  }
  handle3rdBusinessPartyData(e, value) {
    this.setState({
      businessDataSource: value,
    });
  }
  handleSegmentationSystem(e, value) {
    this.setState({
      segmentationSystem: value,
    });
  }
  handleAppendSegment(e, value) {
    this.setState({
      appendSegmentation: value === "append_seg" ? true : false,
    });
  }
  handleSalesforceId(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        salesForceId: value,
      },
    });
  }
  handleEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  handleContractNumber(e, value) {
    if (value === "" && /^(account manager)/gi.test(this.props.roleName)) {
      this.setState({
        ifShowContractNumber: true,
        contractNumberText: "Please add a contract number",
      });
    } else if (
      value === "" &&
      /^(system administrator)/gi.test(this.props.roleName)
    ) {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          contractNumber: null,
        },
        contractNumberText: "",
        ifShowContractNumber: false,
      });
    } else if (!/^[0-9]{8}$/g.test(value) && value !== "") {
      this.setState({
        ifShowContractNumber: true,
        requestParams: {
          ...this.state.requestParams,
        },
        contractNumberText: "The contract number must be an 8 byte integer",
      });
    } else {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          contractNumber: value,
        },
        ifShowContractNumber: false,
        contractNumberText: "",
      });
    }
  }
  handelChangeContractNumb(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        contractNumber: value,
      },
    });
  }
  handleChangeSalesforceId(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        salesForceId: value,
      },
    });
  }
  handleChangeEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  handleClickDateWrapper() {
    let eles = document.querySelectorAll(".react-datepicker__day-name");
    // change month name
    for (const v of eles) {
      v.innerText = v.innerText.substring(0, 1);
    }
  }
  handleOnMonthChange(date) {
    this.setState({
      compareStartDate: date,
    });
  }
  handleStartDateChange(startDate) {
    this.props.startDateChange(
      startDate ? startDate.format("YYYY-MM-DD") : null,
    );

    if (startDate) {
      this.handleChange({ startDate });
    } else {
      this.setState({ startDate: null });
    }
  }
  clickOutsiteDatePicker(type) {
    switch (type) {
      case "end":
        this.refs.endDatePicker.cancelFocusInput();
        this.refs.endDatePicker.setOpen(false);
        break;
      case "start":
      default:
        this.refs.startDatePicker.cancelFocusInput();
        this.refs.startDatePicker.setOpen(false);
        break;
    }
  }
  renderAccountDownloadConfig() {
    return (
      <div
        className="clearfix"
        style={{
          paddingTop: "16px",
          paddingBottom: "16px",
          marginBottom: "30px",
          borderTop: "1px solid #B1B0B0",
          borderBottom: "1px solid #B1B0B0",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            paddingBottom: "20px",
          }}
        >
          Account Download Options
        </div>
        <p
          style={{
            float: "left",
            fontWeight: "bolder",
            width: "30%",
            lineHeight: "1.2",
          }}
        >
          Desired Granularity<em style={{ color: "red" }}>*</em>
        </p>
        <div
          style={{
            float: "left",
            marginTop: "20px",
            marginBottom: "20px",
            minWidth: "400px",
            width: "60%",
          }}
        >
          <RadioButtonGroup
            name="download"
            valueSelected={this.state.audienceResolutionGranularity}
            onChange={(e, value) => this.handleAccoundDownloadOptions(e, value)}
          >
            <RadioButton
              value="Precision"
              label="Precision: Z+6 matches only"
              iconStyle={{ fill: "black", width: "20px", height: "20px" }}
            />
            <RadioButton
              value="Scale"
              label="Scale: Z+6 matches where available/ Z+4 fallback"
              iconStyle={{ fill: "black", width: "20px", height: "20px" }}
            />
          </RadioButtonGroup>
        </div>
      </div>
    );
  }
  renderProfessionalConfig() {
    return (
      <div
        className="clearfix"
        style={{
          paddingTop: "16px",
          paddingBottom: "16px",
          marginBottom: "30px",
          borderTop: "1px solid #B1B0B0",
          borderBottom: "1px solid #B1B0B0",
        }}
      >
        {this.state.requestParams.subscriptionTierId === 4 && (
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              paddingBottom: "20px",
            }}
          >
            Professional Subscription Tier
          </div>
        )}
        <p
          style={{
            float: "left",
            fontWeight: "bolder",
            width: "30%",
            lineHeight: "1.2",
          }}
        >
          Maximum Monthly Records<em style={{ color: "red" }}>*</em>
        </p>
        <div style={{ float: "left", width: "60%" }}>
          <label style={{ fontWeight: "bold" }}>Consumer</label>
          {this.state.requestParams.subscriptionTierId === 1 && (
            <div>
              {/*
              <RadioButtonGroup name="consumer" defaultSelected='InfoGroup' onChange={(e, value) => this.handle3rdPartyData(e, value)}>
                <RadioButton
                  value="InfoGroup"
                  label="InfoGroup"
                  iconStyle={{fill: 'black', width: '20px', height: '20px'}}
                />
                <RadioButton
                  value="Experian"
                  label="Experian"
                  disabled={!(this.state.requestParams.subscriptionTierId === 1)}
                  iconStyle={{fill: 'black', width: '20px', height: '20px'}}
                />
            </RadioButtonGroup>*/}
              <section style={{ marginBottom: "29px" }}>
                <span>
                  Maximum Monthly Consumer Records{" "}
                  <input
                    disabled={/^(administrator|team member)/gi.test(
                      this.props.roleInfo,
                    )}
                    onBlur={(e) => this.handleConsumerRecords(e)}
                    ref="consumer"
                    type="text"
                    style={{
                      textAlign: "center",
                      border: /^(administrator|team member)/gi.test(
                        this.props.roleInfo,
                      )
                        ? "none"
                        : "1px solid #B1B0B0",
                      width: "49px",
                      height: "30px",
                      marginLeft: /^(administrator|team member)/gi.test(
                        this.props.roleInfo,
                      )
                        ? "0"
                        : "15px",
                    }}
                  />
                </span>
              </section>
            </div>
          )}
          {this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5 && (
              <div>
                <section style={{ marginBottom: "29px" }}>
                  <span>
                    Maximum Monthly Consumer Records{" "}
                    <input
                      disabled={/^(administrator|team member)/gi.test(
                        this.props.roleInfo,
                      )}
                      onBlur={(e) => this.handleConsumerRecords(e)}
                      ref="consumer"
                      type="text"
                      style={{
                        textAlign: "center",
                        border: /^(administrator|team member)/gi.test(
                          this.props.roleInfo,
                        )
                          ? "none"
                          : "1px solid #B1B0B0",
                        width: "49px",
                        height: "30px",
                        marginLeft: /^(administrator|team member)/gi.test(
                          this.props.roleInfo,
                        )
                          ? "0"
                          : "15px",
                      }}
                    />
                  </span>
                </section>
              </div>
            )}
          <label style={{ fontWeight: "bold" }}>Business</label>
          {/*
        <RadioButtonGroup name="Business" defaultSelected="InfoGroup">
          <RadioButton
            value="InfoGroup"
            label="InfoGroup"
            iconStyle={{fill: 'black', width: '20px', height: '20px'}}
          />
        </RadioButtonGroup>*/}
          <section>
            <span>
              Maximum Monthly Business Records{" "}
              <input
                disabled={/^(administrator|team member)/gi.test(
                  this.props.roleInfo,
                )}
                onBlur={(e) => this.handleBusinessRecords(e)}
                ref="business"
                type="text"
                style={{
                  textAlign: "center",
                  border: /^(administrator|team member)/gi.test(
                    this.props.roleInfo,
                  )
                    ? "none"
                    : "1px solid #B1B0B0",
                  width: "49px",
                  height: "30px",
                  marginLeft: /^(administrator|team member)/gi.test(
                    this.props.roleInfo,
                  )
                    ? "8px"
                    : "22px",
                }}
              />
            </span>
          </section>
        </div>
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <p
              style={{
                float: "left",
                marginTop: "20px",
                fontWeight: "bolder",
                width: "30%",
              }}
            >
              Data Source - Consumer
            </p>
          )}
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <div
              style={{
                float: "left",
                marginTop: "20px",
                marginBottom: "20px",
                minWidth: "400px",
                width: "60%",
              }}
            >
              <RadioButtonGroup
                name="consumer"
                defaultSelected={
                  window.location.href.indexOf("app.") >= 0
                    ? "InfoGroup"
                    : "Epsilon"
                }
                onChange={(e, value) => this.handle3rdPartyData(e, value)}
              >
                <RadioButton
                  value="InfoGroup"
                  label="InfoGroup"
                  iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                />
                <RadioButton
                  value="Epsilon"
                  label="Epsilon"
                  disabled={window.location.href.indexOf("app.") >= 0}
                  /*disabled={!(this.state.requestParams.subscriptionTierId === 1)}*/
                  iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                />
              </RadioButtonGroup>
            </div>
          )}
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <p
              style={{
                float: "left",
                marginTop: "20px",
                fontWeight: "bolder",
                width: "30%",
              }}
            >
              Data Source - Business
            </p>
          )}
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <div
              style={{
                float: "left",
                marginTop: "20px",
                marginBottom: "20px",
                minWidth: "400px",
                width: "60%",
              }}
            >
              <RadioButtonGroup
                name="consumer"
                defaultSelected="InfoGroup"
                onChange={(e, value) =>
                  this.handle3rdBusinessPartyData(e, value)
                }
              >
                <RadioButton
                  value="InfoGroup"
                  label="InfoGroup"
                  iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                />
              </RadioButtonGroup>
            </div>
          )}
        {this.state.requestParams.subscriptionTierId == 4 && (
          <p
            style={{
              float: "left",
              marginTop: "20px",
              fontWeight: "bolder",
              width: "30%",
            }}
          >
            Segmentation System
          </p>
        )}
        {this.state.requestParams.subscriptionTierId == 4 && (
          <div
            style={{
              float: "left",
              marginTop: "20px",
              marginBottom: "20px",
              minWidth: "400px",
            }}
          >
            <RadioButtonGroup
              name="segmentation"
              defaultSelected="prizm_premier"
              onChange={(e, value) => this.handleSegmentationSystem(e, value)}
            >
              <RadioButton
                value="prizm_premier"
                label="PRIZM Premier"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="psycle_premier"
                label="P$YCLE Premier"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="connexions"
                label="ConneXions"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
            </RadioButtonGroup>
          </div>
        )}
        {this.state.requestParams.subscriptionTierId > 4 && (
          <p
            style={{
              float: "left",
              marginTop: "20px",
              fontWeight: "bolder",
              width: "30%",
            }}
          >
            Append Segmentation to File
          </p>
        )}
        {this.state.requestParams.subscriptionTierId > 4 && (
          <div
            style={{
              float: "left",
              marginTop: "20px",
              marginBottom: "20px",
              minWidth: "400px",
            }}
          >
            <RadioButtonGroup
              name="segmentation"
              defaultSelected="no_append_seg"
              onChange={(e, value) => this.handleAppendSegment(e, value)}
            >
              <RadioButton
                value="append_seg"
                label="Yes"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="no_append_seg"
                label="No"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
            </RadioButtonGroup>
          </div>
        )}
        {this.state.requestParams.subscriptionTierId > 4 &&
          this.state.appendSegmentation && (
            <InputField
              labelTitle={"Segmentation License Number"}
              ifRequireField={true}
              borderColor={"#B1B0B0"}
              onChange={(e, value) => this.handleLicenseNumber(e, value)}
              borderCorlor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontWeight: "bolder",
                width: "30%",
                lineHeight: "1.2",
                margin: 0,
                lineHeight: "18px",
                marginTop: "8px",
              }}
              inputContainerId="firstName"
              style={{
                height: "32px",
                lineHeight: "32px",
                marginBottom: "30px",
                zIndex: 2000,
              }}
            />
          )}
        {this.state.requestParams.subscriptionTierId > 4 &&
          this.state.appendSegmentation && (
            <div
              className="role clearfix"
              style={{
                lineHeight: "32px",
                position: "relative",
                marginBottom: "20px",
                marginTop: "150px",
              }}
            >
              <p
                style={{
                  color: "black",
                  float: "left",
                  width: "30%",
                  margin: 0,
                  fontWeight: "bolder",
                  position: "absolute",
                  bottom: "5px",
                }}
              >
                Expiration Date<em style={{ color: "red" }}>*</em>
              </p>
              <div
                className="content clearfix "
                style={{ paddingLeft: "30px", width: "80%" }}
              >
                <Select
                  className="date-selector month-selector z-index-199"
                  value={this.state.expMonth}
                  clearable={false}
                  options={this.state.months}
                  onChange={(date) => this.handleExpMonthChange(date)}
                  placeholder={"MM"}
                />
                <span
                  className="pl-20 pr-20"
                  style={{ position: "absolute", bottom: "10px" }}
                >
                  -
                </span>
                <Select
                  className="date-selector year-selector z-index-199"
                  value={this.state.expYear}
                  clearable={false}
                  options={this.state.years}
                  onChange={(date) => this.handleExpYearChange(date)}
                  placeholder={"YYYY"}
                />
              </div>
            </div>
          )}
        {this.state.requestParams.subscriptionTierId == 4 &&
          this.state.appendSegmentation && (
            <div className="profile-fn-wrapper" style={{ marginTop: "1em" }}>
              {this.state.licenseErrorText &&
                this.state.licenseErrorText !== "" && (
                  <section className="create-profile-error clearfix">
                    <Error style={{ float: "left" }} color="red" />
                    <span>{this.state.licenseErrorText}</span>
                  </section>
                )}
            </div>
          )}
      </div>
    );
  }
  renderTeamMembers(isClientAdmin) {
    if (
      /^(administrator|team member)/gi.test(this.props.roleName) &&
      isEmpty(this.props.teamMember_options)
    ) {
      return "";
    }
    return (
      <div
        className="role clearfix"
        style={{ lineHeight: "32px", marginBottom: "30px" }}
      >
        <p
          style={{
            marginTop: "10px",
            color: "black",
            float: "left",
            width: "30%",
            lineHeight: /^(administrator|team member)/gi.test(
              this.props.roleName,
            )
              ? "1.3em"
              : "",
            fontWeight: "bolder",
          }}
        >
          {/^(administrator|team member)/gi.test(this.props.roleName)
            ? "Assign Business Unit to"
            : "Assign Client to"}
          <em
            style={{ color: "red", display: isClientAdmin ? "none" : "inline" }}
          >
            *
          </em>
        </p>

        <Select
          style={{ width: "68%", height: "32px" }}
          multi
          className="cp-state-selector"
          value={this.state.assignClientValue}
          clearable={true}
          simpleValue
          options={
            /^(administrator|team member)/gi.test(this.props.roleName)
              ? this.props.teamMember_options
              : this.props.account_manager
          }
          onChange={this.handleAssignClientChange.bind(this)}
        />
      </div>
    );
  }
  render() {
    const muiTheme = getMuiTheme({
      menuItem: {
        hoverColor: buttonBlueColor(),
      },
    });
    const isClientAdmin = /^(administrator|team member)/gi.test(
      this.props.roleName,
    );
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div
          className="profile fix-ui"
          style={{ marginTop: "20px", background: "#FFF" }}
        >
          <Dialog
            modal={true}
            contentStyle={{
              width: "40%",
              border: "1px solid black",
              top: "-6em",
            }}
            open={this.props.ifCreateClientProfileSuccess}
            bodyStyle={{ overflowY: "inherit", padding: "20px" }}
          >
            <div className="create-profile-tip">
              <p className="tip">{"The profile was created successfully."}</p>
              <div className="btn-wrapper">
                <button onClick={() => this.handleCloseCreateClientProfile()}>
                  CLOSE
                </button>
              </div>
            </div>
          </Dialog>
          <Dialog
            modal={true}
            contentStyle={{
              width: "40%",
              border: "1px solid black",
              top: "-6em",
            }}
            open={this.props.ifCreateClientProfileSuccessBasic}
            bodyStyle={{ overflowY: "inherit", padding: "20px" }}
          >
            <div className="create-profile-tip">
              <p className="tip">{"The profile was created successfully."}</p>
              <div className="btn-wrapper">
                <button onClick={() => this.handleCloseCreateClientProfile()}>
                  CLOSE
                </button>
              </div>
            </div>
          </Dialog>
          {/*{*/}
          {/*this.props.ifCreateClientProfileSuccess && (*/}
          {/*<div className="create-profile-tip">*/}
          {/*<p className="tip">*/}
          {/*{*/}
          {/*/^(administrator|team member)/gi.test(this.props.roleName) ?*/}
          {/*'The profile was updated successfully.' :*/}
          {/*'The profile was updated successfully.'*/}
          {/*}*/}
          {/*</p>*/}
          {/*<div className="btn-wrapper">*/}
          {/*<button onClick={() => this.handleCloseCreateClientProfile()}>*/}
          {/*CLOSE*/}
          {/*</button>*/}
          {/*</div>*/}
          {/*</div>*/}
          {/*)*/}
          {/*}*/}
          {
            <div className="profile-wrapper">
              <div className="profile-form-top">
                <h1 style={{ border: "none", marginTop: "0.6em" }}>
                  {isClientAdmin
                    ? "CREATE BUSINESS UNIT PROFILE"
                    : "CREATE CLIENT PROFILE"}
                </h1>
                <div className="profile-form">
                  <div className="top">
                    {/*<div className="top-shadow" style={{display: this.state.ifHiddenTopEdit ? 'block' : 'none'}}></div>*/}
                    <div
                      className="profile-fn-wrapper"
                      style={{ marginTop: "1em" }}
                    >
                      <InputField
                        labelTitle={
                          /^(administrator|team member)/gi.test(
                            this.props.roleName,
                          )
                            ? "Business Unit Name"
                            : "Client Name"
                        }
                        ifRequireField={true}
                        borderColor={"#B1B0B0"}
                        onChange={(e, value) => this.handleClientName(e, value)}
                        labelStyle={{
                          float: "left",
                          fontWeight: "bolder",
                          width: "30%",
                          margin: 0,
                          lineHeight: "18px",
                          marginTop: "8px",
                        }}
                        inputContainerId="firstName"
                        style={{ lineHeight: "32px", marginBottom: "30px" }}
                      />
                      {this.state.requiredNameText !== "" && (
                        <section className="create-profile-error clearfix">
                          {/*<Error style={{ float: "left" }} color="red" />*/}
                          <span>{this.state.requiredNameText}</span>
                        </section>
                      )}
                    </div>
                    <div className="profile-ln-wrapper">
                      <InputField
                        labelTitle={
                          isClientAdmin
                            ? "Business Unit Address 1"
                            : "Client Address 1"
                        }
                        onChange={(e, value) =>
                          this.handleClientAddress1(e, value)
                        }
                        labelStyle={{
                          float: "left",
                          fontWeight: "bolder",
                          width: "30%",
                          lineHeight: "1.2",
                          margin: 0,
                        }}
                        inputContainerId="lastName"
                        borderColor={"#B1B0B0"}
                        style={{ lineHeight: "32px", marginBottom: "30px" }}
                      />
                    </div>
                    <div className="profile-ln-wrapper">
                      <InputField
                        labelTitle={
                          isClientAdmin
                            ? "Business Unit Address 2"
                            : "Client Address 2"
                        }
                        onChange={(e, value) =>
                          this.handleClientAddress2(e, value)
                        }
                        labelStyle={{
                          float: "left",
                          fontWeight: "bolder",
                          width: "30%",
                          lineHeight: "1.2",
                          margin: 0,
                        }}
                        inputContainerId="lastName"
                        borderColor={"#B1B0B0"}
                        style={{ lineHeight: "32px", marginBottom: "30px" }}
                      />
                    </div>
                    <InputField
                      labelTitle="City"
                      labelStyle={{
                        float: "left",
                        fontWeight: "bolder",
                        width: "30%",
                        lineHeight: "1.2",
                        margin: 0,
                      }}
                      onChange={(e, value) => this.handleCity(e, value)}
                      inputContainerId="city"
                      borderColor={"#B1B0B0"}
                      style={{ lineHeight: "32px", marginBottom: "30px" }}
                    />
                    <div
                      className="role clearfix"
                      style={{ lineHeight: "32px", marginBottom: "30px" }}
                    >
                      <p
                        style={{
                          color: "black",
                          float: "left",
                          width: "30%",
                          margin: 0,
                          fontWeight: "bolder",
                        }}
                      >
                        State
                      </p>
                      <Select
                        style={{ width: "68%", height: "32px" }}
                        className="cp-state-selector z-index-199"
                        value={this.state.stateValue}
                        clearable={false}
                        options={this.props.allstates}
                        onChange={this.handleStateChange.bind(this)}
                      />
                    </div>
                    <InputField
                      labelTitle="Zip Code"
                      labelStyle={{
                        float: "left",
                        fontWeight: "bolder",
                        width: "30%",
                        lineHeight: "1.2",
                        margin: 0,
                      }}
                      onChange={(e, value) => this.handleZipCode(e, value)}
                      inputContainerId="zipCode"
                      borderColor={"#B1B0B0"}
                      style={{ lineHeight: "32px", marginBottom: "30px" }}
                    />
                    <div
                      className="role clearfix"
                      style={{ lineHeight: "32px", marginBottom: "30px" }}
                    >
                      <p
                        style={{
                          color: "black",
                          float: "left",
                          width: "30%",
                          margin: 0,
                          fontWeight: "bolder",
                        }}
                      >
                        Time Zone<em style={{ color: "red" }}>*</em>
                      </p>
                      <Select
                        style={{ width: "68%", height: "32px" }}
                        className="cp-state-selector z-index-198"
                        value={this.state.timezoneValue}
                        clearable={false}
                        options={this.props.timezone}
                        onChange={this.handleTimeZoneChange.bind(this)}
                      />
                    </div>
                    {this.state.requiredTimezoneText !== "" && (
                      <section className="create-profile-error clearfix">
                        {/*<Error style={{ float: "left" }} color="red" />*/}
                        <span>{this.state.requiredTimezoneText}</span>
                      </section>
                    )}
                    <div
                      className="profile-mobile-phone-number clearfix"
                      style={{ marginBottom: "30px" }}
                    >
                      <span style={{ marginTop: "10px" }}>Phone Number</span>
                      <MaskedInput
                        className="mp-mask"
                        guide={false}
                        style={{ border: "1px solid #B1B0B0", height: "32px" }}
                        mask={[
                          "(",
                          /[1-9]/,
                          /\d/,
                          /\d/,
                          ")",
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        onChange={(e) => this.handleOfficePhoneNumber(e)}
                      />
                    </div>
                    {/^(system administrator|administrator|team member|account manager)/gi.test(
                      this.props.roleName,
                    ) && (
                      <InputField
                        labelTitle="Account Number"
                        labelStyle={{
                          float: "left",
                          fontWeight: "bolder",
                          width: "30%",
                          lineHeight: "1.2",
                          margin: 0,
                        }}
                        onChange={(e, value) =>
                          this.handleAccountNumber(e, value)
                        }
                        inputContainerId="officeNumber"
                        borderCorlor="#B1B0B0"
                        style={{ lineHeight: "32px", marginBottom: "30px" }}
                      />
                    )}
                    {/*Contract Number*/}
                    {/^\/clients$/g.test(this.props.path) &&
                      /^(account manager|system administrator)/gi.test(
                        this.props.roleName,
                      ) && (
                        <div className="profile-fn-wrapper">
                          <InputField
                            labelTitle="Contract Number"
                            handleOnBlur={(e, value) =>
                              this.handleContractNumber(e, value)
                            }
                            onChange={(e, value) =>
                              this.handelChangeContractNumb(e, value)
                            }
                            ifHasBorder={this.state.ifHiddenTopEdit}
                            initValue={
                              this.state.requestParams.contractNumber === null
                                ? ""
                                : this.state.requestParams.contractNumber
                            }
                            ifRequireField={/^(account manager)/gi.test(
                              this.props.roleName,
                            )}
                            borderCorlor="#B1B0B0"
                            labelStyle={{
                              float: "left",
                              fontWeight: "bolder",
                              width: "30%",
                              margin: 0,
                            }}
                            inputContainerId="firstName"
                            style={{
                              lineHeight: "32px",
                              borderBottom: this.state.ifHiddenTopEdit
                                ? "2px solid grey"
                                : "",
                              marginBottom: !this.state.ifHiddenTopEdit
                                ? "30px"
                                : 0,
                            }}
                          />
                          {this.state.ifShowContractNumber && (
                            <p
                              className="create-account-field-error clearfix"
                              style={{
                                marginBottom: "18px",
                                marginTop: "-10px",
                              }}
                            >
                              <Error style={{ float: "left" }} color="red" />
                              <span>{this.state.contractNumberText}</span>
                            </p>
                          )}
                        </div>
                      )}
                    {/^(system administrator|administrator|team member|account manager)/gi.test(
                      this.props.roleName,
                    ) && (
                      <InputField
                        labelTitle="Salesforce ID"
                        maxLength={20}
                        handleOnBlur={(e, value) =>
                          this.handleSalesforceId(e, value)
                        }
                        onChange={(e, value) =>
                          this.handleChangeSalesforceId(e, value)
                        }
                        ifHasBorder={this.state.ifHiddenTopEdit}
                        initValue={
                          this.state.requestParams.salesForceId === null
                            ? ""
                            : this.state.requestParams.salesForceId
                        }
                        ifRequireField={false}
                        borderCorlor="#B1B0B0"
                        labelStyle={{
                          float: "left",
                          fontWeight: "bolder",
                          width: "30%",
                          margin: 0,
                        }}
                        inputContainerId="firstName"
                        style={{
                          lineHeight: "32px",
                          borderBottom: this.state.ifHiddenTopEdit
                            ? "2px solid grey"
                            : "",
                          marginBottom: !this.state.ifHiddenTopEdit
                            ? "30px"
                            : 0,
                        }}
                      />
                    )}
                    {/^(system administrator|account manager|administrator|team member)/gi.test(
                      this.props.roleInfo,
                    ) &&
                      /^(\/clients\/edit\/Business-Units\/:id|\/clients)/g.test(
                        this.props.path,
                      ) && (
                        <div
                          className="role clearfix"
                          style={{ lineHeight: "32px", marginBottom: "10px" }}
                        >
                          <p
                            style={{
                              color: "black",
                              float: "left",
                              width: "30%",
                              margin: 0,
                              fontWeight: "bolder",
                            }}
                          >
                            Subscription Tier{" "}
                            <em style={{ color: "red" }}>*</em>
                          </p>
                          <div style={{ float: "left" }}>
                            <RadioButtonGroup
                              name="clientTier"
                              defaultSelected={this.state.subscriptionTierValue}
                              onChange={(e, value) =>
                                this.handleSubscriptionTierChange(value)
                              }
                            >
                              <RadioButton
                                value={2}
                                label="Basic"
                                iconStyle={{
                                  fill: "black",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <RadioButton
                                value={3}
                                label="Standard"
                                iconStyle={{
                                  fill: "black",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <RadioButton
                                value={4}
                                label="Professional"
                                iconStyle={{
                                  fill: "black",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <RadioButton
                                value={5}
                                disabled={isClientAdmin}
                                label="Optimize"
                                iconStyle={{
                                  fill: "black",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                            </RadioButtonGroup>
                          </div>
                        </div>
                      )}
                    {this.state.requestParams.subscriptionTierId >= 3 &&
                      this.state.requestParams.subscriptionTierId != 5 &&
                      /^(system administrator|account manager|administrator|team member)/gi.test(
                        this.props.roleInfo,
                      ) &&
                      /^(\/clients\/edit\/Business-Units\/:id$)/g.test(
                        this.props.path,
                      ) &&
                      this.renderAccountDownloadConfig()}
                    {this.state.requestParams.subscriptionTierId >= 3 &&
                      this.state.requestParams.subscriptionTierId != 5 &&
                      /^(system administrator|account manager)/gi.test(
                        this.props.roleInfo,
                      ) &&
                      /^(\/clients)$/g.test(this.props.path) &&
                      this.renderAccountDownloadConfig()}
                    {this.state.requestParams.subscriptionTierId >= 3 &&
                      this.state.requestParams.subscriptionTierId != 5 &&
                      /^(system administrator|account manager|administrator|team member)/gi.test(
                        this.props.roleInfo,
                      ) &&
                      /^(\/clients\/edit\/Business-Units\/:id$)/g.test(
                        this.props.path,
                      ) &&
                      /*
                          <div style={{display: this.state.ifHiddenTopEdit ? 'none' : 'block', paddingLeft: '30%', paddingBottom: '29px'}}>
                            <section style={{marginBottom: '29px'}}>
                              <span>Maximum Monthly Consumer Records<input disabled={/^(administrator|team member)/gi.test(this.props.roleInfo)} onBlur={(e) => this.handleConsumerRecords(e)} ref="consumer" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? '0' : '15px'}}/></span>
                            </section>
                            <section>
                              <span>Maximum Monthly Business Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleInfo)} onBlur={(e) => this.handleBusinessRecords(e)} ref="business" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleInfo) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleInfo) ? '8px' : '22px'}}/></span>
                            </section>
                          </div>*/
                      this.renderProfessionalConfig()}
                    {/*for create client profile*/}
                    {(this.state.requestParams.subscriptionTierId === 1 ||
                      (this.state.requestParams.subscriptionTierId >= 3 &&
                        this.state.requestParams.subscriptionTierId != 5)) &&
                      /^(system administrator|account manager)/gi.test(
                        this.props.roleInfo,
                      ) &&
                      /^(\/clients)$/g.test(this.props.path) &&
                      this.renderProfessionalConfig()}

                    {this.state.requiredTierText !== "" && (
                      <section className="create-profile-error clearfix">
                        <Error style={{ float: "left" }} color="red" />
                        <span>{this.state.requiredTierText}</span>
                      </section>
                    )}
                    {/^(system administrator|account manager)/gi.test(
                      this.props.roleInfo,
                    ) &&
                      this.state.requestParams.subscriptionTierId === 5 && (
                        <InputField
                          labelTitle="Email"
                          maxLength={120}
                          handleOnBlur={(e, value) =>
                            this.handleEmail(e, value)
                          }
                          onChange={(e, value) =>
                            this.handleChangeEmail(e, value)
                          }
                          ifHasBorder={this.state.ifHiddenTopEdit}
                          initValue={
                            this.state.requestParams.email === null
                              ? ""
                              : this.state.requestParams.email
                          }
                          ifRequireField={true}
                          borderCorlor="#B1B0B0"
                          labelStyle={{
                            float: "left",
                            fontWeight: "bolder",
                            width: "30%",
                            margin: 0,
                          }}
                          inputContainerId="firstName"
                          style={{
                            lineHeight: "32px",
                            borderBottom: this.state.ifHiddenTopEdit
                              ? "2px solid grey"
                              : "",
                            marginBottom: !this.state.ifHiddenTopEdit
                              ? "30px"
                              : 0,
                          }}
                        />
                      )}
                    {/^(system administrator|account manager)/gi.test(
                      this.props.roleInfo,
                    ) &&
                      this.state.requestParams.subscriptionTierId === 5 &&
                      this.state.requiredEmailText !== "" && (
                        <section className="create-profile-error clearfix">
                          <Error style={{ float: "left" }} color="red" />
                          <span>{this.state.requiredEmailText}</span>
                        </section>
                      )}
                    {/^(system administrator|account manager)/gi.test(
                      this.props.roleInfo,
                    ) && (
                      <div
                        className="role clearfix"
                        style={{ lineHeight: "32px", marginBottom: "30px" }}
                      >
                        <p
                          style={{
                            color: "black",
                            float: "left",
                            width: "30%",
                            margin: 0,
                            fontWeight: "bolder",
                          }}
                        >
                          Campaign Reporting <em style={{ color: "red" }}>*</em>
                        </p>
                        <div
                          style={{
                            float: "left",
                            minWidth: "400px",
                            with: "68%",
                          }}
                        >
                          <RadioButtonGroup
                            name="clientTier"
                            valueSelected={
                              this.state.requestParams.campaignReportPreference
                            }
                            onChange={(e, value) => {
                              e.preventDefault();
                              this.handleCampaignReportChanged(value);
                            }}
                          >
                            <RadioButton
                              value={"Aggregated"}
                              label="Aggregate"
                              iconStyle={{
                                fill: "black",
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            <RadioButton
                              value={"Detailed"}
                              label="Detailed Campaign Reporting"
                              iconStyle={{
                                fill: "black",
                                width: "20px",
                                height: "20px",
                              }}
                            />
                          </RadioButtonGroup>
                          <div
                            className="pt-10"
                            style={{
                              borderTop: "solid 1px #000000",
                              display:
                                this.state.requestParams
                                  .campaignReportPreference === "Detailed"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <Checkbox
                              label="Display Top Locations on Channel Reports"
                              onCheck={(e, isInputChecked) =>
                                this.handleTopLocationReportCheck(
                                  e,
                                  isInputChecked,
                                )
                              }
                              iconStyle={styles.iconStyle}
                              labelStyle={styles.labelStyle}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className="role clearfix"
                      style={{ lineHeight: "32px", marginBottom: "30px" }}
                    >
                      <p
                        style={{
                          color: "black",
                          float: "left",
                          width: "30%",
                          margin: 0,
                          fontWeight: "bolder",
                        }}
                      >
                        Industry Type<em style={{ color: "red" }}>*</em>
                      </p>

                      <div
                        className="ac-clients-select-filed"
                        id="industryType"
                        style={{ width: "68%", height: "34px" }}
                      >
                        <CustomSelect
                          placeholder="Select Industry Type"
                          options={this.state.industryGroupObj}
                          onChange={(value) => this.handleIndustryChange(value)}
                        />
                      </div>
                    </div>
                    {this.state.requiredIndustryIdText !== "" && (
                      <section className="create-profile-error clearfix">
                        {/*<Error style={{ float: "left" }} color="red" />*/}
                        <span>{this.state.requiredIndustryIdText}</span>
                      </section>
                    )}

                    {!/^(account manager|team member)/gi.test(
                      this.props.roleName,
                    ) && this.renderTeamMembers(isClientAdmin)}

                    {this.state.requiredAssignClientText !== "" && (
                      <section className="create-profile-error clearfix">
                        {/*<Error style={{ float: "left" }} color="red" />*/}
                        <span>{this.state.requiredAssignClientText}</span>
                      </section>
                    )}
                  </div>
                </div>
              </div>

              <div className="profile-logo-wrapper">
                {typeof this.props.loginUserDetail !== "undefined" &&
                /^(account manager|team member|system administrator|administrator)/gi.test(
                  this.props.roleName,
                ) ? (
                  <div className="profile-logo profile-company-logo clearfix">
                    <div className="clearfix">
                      <div className="title clearfix">
                        <span id="profile-subtit">LOGO</span>
                      </div>
                      <div className="review">
                        {/*<img src={localStorage.getItem('newLogoBase64') !== '' ? localStorage.getItem('newLogoBase64') : (this.state.imgDataBase64 || loading)} alt="" style={{display: this.state.ifHiddenLogoEdit ? 'inline-block' : 'none'}}/>*/}
                        <div className="profile-edit-img">
                          <section className="section">
                            Select a logo to upload
                          </section>
                          <Dropzone
                            onDrop={(files, accept, reject) =>
                              this.handleDrop(files, accept, reject)
                            }
                            style={{ width: "100%", marginTop: "5px" }}
                            accept="image/jpeg, image/png, image/jpg, image/gif"
                            maxSize={1048576}
                            onDropRejected={() => this.onDropRejected()}
                            name="logo"
                          >
                            <p
                              style={{
                                textAlign: "center",
                                display: "inline-block",
                                width: "20%",
                                height: "20px",
                                fontSize: "12px",
                                border: "1px solid grey",
                                color: "black",
                                borderRadius: "6px",
                                lineHeight: "20px",
                                marginTop: "10px",
                              }}
                            >
                              Choose File
                            </p>
                            <i
                              style={{ fontStyle: "normal", marginLeft: "6px" }}
                            >
                              {(this.state.logoFileName !== undefined &&
                                this.state.logoFileName.name) ||
                                "No file chosen"}
                            </i>
                            <section className="spec">
                              (Only jpg, png, and gif file with maximum size of
                              1MB is allowed)
                            </section>
                          </Dropzone>
                          <img src={this.state.newLogoBase64} alt="" />
                          <button
                            style={{
                              background: buttonBlueColor(),
                              padding: "5px 10px",
                            }}
                            onClick={() => this.handleUploadLogo()}
                          >
                            UPLOAD LOGO
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="error" style={{ marginLeft: "150px" }}>
                      {this.props.update_logo_msg ||
                        this.state.companyLogoErrorText}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="profile-edit clearfix">
                  <div
                    className="save-group clearfix"
                    style={{ position: "relative" }}
                  >
                    <section className="create-profile-s-error">
                      {this.props.createClientProfileMessage}
                    </section>
                    <button
                      className="save"
                      style={{ background: buttonBlueColor() }}
                      onClick={() => this.handleUpdateProfile()}
                    >
                      SAVE
                    </button>
                    <button
                      className="cancel"
                      onClick={() => this.handleClientProfileCancel()}
                      style={{ fontWeight: "bolder", background: "white" }}
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Clients/ClientProfile.jsx